export default "__VITE_ASSET__vPBSTf3Z__"